import { Channel, FMSLocationData, FMSSyncedLocationData, SessionInterface, TwilioCallStatus, UserInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Sessions/Sessions.Controller.ts

export class SessionsAPI {
  static async takeoverConversationOnChannel(orgId: number, userId: number, channel: Channel, memberId: number): Promise<SessionInterface> {
    return APIService.Server.put<SessionInterface>(`/sessions/org/${orgId}/user/${userId}/channel/${channel}/member/${memberId}/takeover`);
  }
  // static async takeOverSession(orgId: number, sessionId: number, memberId: number): Promise<SessionInterface> {
  //   return APIService.Server.put<SessionInterface>(`/sessions/org/${orgId}/session/${sessionId}/member/${memberId}/takeover`);
  // }
  static async endTakenOverSession(orgId: number, sessionId: number, memberId: number): Promise<SessionInterface> {
    return APIService.Server.put<SessionInterface>(`/sessions/org/${orgId}/session/${sessionId}/member/${memberId}/end-takeover`);
  }
  static async getActiveSessions(orgId: number): Promise<SessionInterface[]> {
    return APIService.Server.get<SessionInterface[]>(`/sessions/org/${orgId}`);
  }

  static async getOrCreateSession(orgId: number, userId: number, channel: Channel = Channel.WEB, callSid?: string) {
    return APIService.Server.get<{ session: SessionInterface; isNew: Boolean }>(`/sessions/org/${orgId}/user/${userId}/channel/${channel}`, {
      callSid,
    });
  }
  static async getSessionByCallSid(callSid: string) {
    return APIService.Server.get<SessionInterface | null>(`/sessions/call/${callSid}`);
  }
  static async updateSession(orgId: number, sessionId: number, session: Partial<SessionInterface>) {
    return APIService.Server.put<SessionInterface>(`/sessions/org/${orgId}/session/${sessionId}`, session);
  }

  static async removeMergedSessions(
    orgId: number,
    userId: number,
    mergedInto: number,
    channel: Channel,
  ): Promise<{ mergedSessions: SessionInterface[] }> {
    return APIService.Server.put<{ mergedSessions: SessionInterface[] }>(
      `/sessions/org/${orgId}/user/${userId}/channel/${channel}/merged-into/${mergedInto}`,
    );
  }

  static async updateCallStatus(callSid: string, callStatus: TwilioCallStatus): Promise<SessionInterface | null> {
    return APIService.Server.put<SessionInterface | null>(`/sessions/call/${callSid}/status/${callStatus}`);
  }
}
